import React from "react";
import { Button, DialogActions, CircularProgress } from "@mui/material";

const ModalActions = ({
  onCancel,
  onConfirm,
  confirmLabel = "Apply Changes",
  confirmColor = "#3b82f6",
  confirmHoverColor = "#2563eb",
  disabled = false,
  loading = false,
}) => (
  <DialogActions
     sx={{
    p: 2.5,
    borderTop: "1px solid rgba(255,255,255,0.08)",
    flexShrink: 0,         
    background: "#1a1a1a", 
    zIndex: 1,
  }}
  >
    <Button
      onClick={onCancel}
      sx={{
        textTransform: "none",
        borderRadius: "8px",
        px: 2.5,
        color: "text.secondary",
        "&:hover": { color: "text.primary" },
      }}
    >
      Cancel
    </Button>
    <Button
      variant="contained"
      onClick={onConfirm}
      disabled={disabled || loading}
      startIcon={
        loading ? <CircularProgress size={16} color="inherit" /> : null
      }
      sx={{
        background: confirmColor,
        "&:hover": { background: confirmHoverColor },
        "&.Mui-disabled": {
          background: "rgba(255,255,255,0.1)",
          color: "rgba(255,255,255,0.3)",
        },
        textTransform: "none",
        borderRadius: "8px",
        px: 3,
        py: 1,
        fontWeight: 600,
      }}
    >
      {confirmLabel}
    </Button>
  </DialogActions>
);

export default ModalActions;